/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    bold: {
      description: 'Sets the font weight, to bold on some body text styles. Does not change accessibility properties.',
      type: 'variant',
      values: [ true ]
    },
    colour: {
      description: 'Each typography variant has a default color, and at least a secondary color variant. In exceptional cases where a different colour is needed,\n' +
        '  use the tokens prop.',
      type: 'variant',
      values: [
        'default',      'brand',
        'dark',         'light',
        'positive',     'warning',
        'danger',       'black',
        'white',        'brand2',
        'brand3',       'alternative1',
        'alternative2', 'alternative3'
      ]
    },
    compact: {
      description: 'Reduces line height on some body text styles. For data-rich content, not for flow content',
      type: 'variant',
      values: [ true ]
    },
    inverse: {
      description: 'Styles the link white for use on dark backgrounds.',
      type: 'variant',
      values: [ true ]
    },
    size: {
      description: 'Styles text as body or heading text with a given size. Smaller numbers indicate larger sizes,\n' +
        '"display" headings are larger than "h" headings. Default is medium size body text. Does not change\n' +
        'accessibility or SEO-related properties; use the heading prop if text should be treated semantically as a heading.',
      type: 'variant',
      values: [
        'micro',    'small',
        'large',    'eyebrow',
        'h1',       'h2',
        'h3',       'h4',
        'h5',       'h6',
        'display1', 'display2'
      ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    },
    weight: {
      description: 'Sets the font weight, default is regular 400 weight. Does not change accessibility properties.',
      type: 'variant',
      values: [ 'semibold', 'bold' ]
    }
  },
  rules: [
    {
      if: { size: [ 'display1', 'display2', 'h1', 'h2', 'h3' ] },
      tokens: { color: '#4b286d' }
    },
    {
      if: {
        colour: 'dark',
        size: [ 'display1', 'display2', 'h1', 'h2', 'h3' ]
      },
      tokens: { color: '#2c2e30' }
    },
    {
      if: { colour: 'light', size: 'h6' },
      tokens: { color: '#676e73' }
    },
    {
      if: { colour: 'dark', size: 'eyebrow' },
      tokens: { color: '#7c53a5' }
    },
    { if: { inverse: true }, tokens: { color: '#ffffff' } },
    {
      if: { size: 'display1' },
      tokens: {
        fontName: 'HNforTELUSSA',
        fontSize: 40,
        fontWeight: '300',
        letterSpacing: 0,
        lineHeight: 1.2,
        superScriptFontSize: 24
      }
    },
    {
      if: { size: 'display1', viewport: [ 'lg', 'xl' ] },
      tokens: {
        fontName: 'HNforTELUSSA',
        fontSize: 64,
        fontWeight: '300',
        lineHeight: 1.2,
        superScriptFontSize: 32
      }
    },
    {
      if: { size: 'display2' },
      tokens: {
        fontName: 'HNforTELUSSA',
        fontSize: 36,
        fontWeight: '300',
        letterSpacing: 0,
        lineHeight: 1.22222222222,
        superScriptFontSize: 24
      }
    },
    {
      if: { size: 'display2', viewport: [ 'lg', 'xl' ] },
      tokens: {
        fontName: 'HNforTELUSSA',
        fontSize: 56,
        fontWeight: '300',
        lineHeight: 1.14285714286,
        superScriptFontSize: 32
      }
    },
    {
      if: { size: 'h1' },
      tokens: {
        fontName: 'HNforTELUSSA',
        fontSize: 28,
        fontWeight: '300',
        letterSpacing: 0,
        lineHeight: 1.22222222222,
        superScriptFontSize: 20
      }
    },
    {
      if: { size: 'h1', viewport: [ 'lg', 'xl' ] },
      tokens: {
        fontName: 'HNforTELUSSA',
        fontSize: 40,
        fontWeight: '300',
        letterSpacing: 0,
        lineHeight: 1.2,
        superScriptFontSize: 24
      }
    },
    {
      if: { size: 'h2' },
      tokens: {
        fontName: 'HNforTELUSSA',
        fontSize: 24,
        fontWeight: '300',
        letterSpacing: 0,
        lineHeight: 1.2,
        superScriptFontSize: 16
      }
    },
    {
      if: { size: 'h2', viewport: [ 'lg', 'xl' ] },
      tokens: {
        fontName: 'HNforTELUSSA',
        fontSize: 28,
        fontWeight: '300',
        letterSpacing: -0.017,
        lineHeight: 1.22222222222,
        superScriptFontSize: 20
      }
    },
    {
      if: { size: 'h3' },
      tokens: {
        fontName: 'HNforTELUSSA',
        fontSize: 20,
        fontWeight: '500',
        letterSpacing: 0,
        lineHeight: 1.2,
        superScriptFontSize: 16
      }
    },
    {
      if: { size: 'h4' },
      tokens: {
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '500',
        letterSpacing: 0,
        lineHeight: 1.5,
        superScriptFontSize: 16
      }
    },
    {
      if: { size: 'h5' },
      tokens: {
        fontName: 'HNforTELUSSA',
        fontSize: 14,
        fontWeight: '500',
        letterSpacing: 0,
        lineHeight: 1.28571428571
      }
    },
    {
      if: { size: [ 'h5', 'h6' ] },
      tokens: { superScriptFontSize: 12 }
    },
    {
      if: { size: 'h6' },
      tokens: {
        fontName: 'HNforTELUSSA',
        fontSize: 12,
        fontWeight: '700',
        letterSpacing: 0,
        lineHeight: 1.33333333333
      }
    },
    {
      if: { size: 'large' },
      tokens: { fontSize: 20, lineHeight: 1.6, superScriptFontSize: 16 }
    },
    {
      if: { compact: true, size: 'large' },
      tokens: { lineHeight: 1.2 }
    },
    {
      description: "The compact line height for the 'default' font size, but doesn't apply for any other styles",
      if: { compact: true, size: null },
      tokens: { lineHeight: 1.25 }
    },
    {
      if: { size: 'small' },
      tokens: {
        fontSize: 14,
        lineHeight: 1.42857142857,
        superScriptFontSize: 12
      }
    },
    {
      if: { compact: true, size: 'small' },
      tokens: { lineHeight: 1.14285714286 }
    },
    {
      if: { size: 'micro' },
      tokens: {
        fontName: 'HNforTELUSSA',
        fontSize: 12,
        fontWeight: '500',
        lineHeight: 1.33333333333,
        superScriptFontSize: 12
      }
    },
    {
      if: { size: 'eyebrow' },
      tokens: {
        color: '#7c53a5',
        fontName: 'HNforTELUSSA',
        fontSize: 14,
        fontWeight: '700',
        lineHeight: 1.42857142857,
        textTransform: 'uppercase'
      }
    },
    {
      description: 'Please only bold single words while using with headings',
      if: { bold: true },
      tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
    },
    {
      if: { bold: true, size: 'micro' },
      tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
    },
    {
      if: { bold: true, size: 'display1' },
      tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
    },
    {
      if: { bold: true, size: 'display2' },
      tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
    },
    {
      if: { bold: true, size: 'h1' },
      tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
    },
    {
      if: { bold: true, size: 'h2' },
      tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
    },
    {
      if: { bold: true, size: 'h3' },
      tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
    },
    {
      if: {
        bold: true,
        size: [ 'h4', 'h5', 'h6' ],
        viewport: [ 'xs', 'sm', 'md' ]
      },
      tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
    },
    {
      if: { weight: 'semibold' },
      tokens: { fontName: 'HNforTELUSSA', fontWeight: '500' }
    },
    {
      if: { weight: 'bold' },
      tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
    },
    { if: { colour: 'default' }, tokens: { color: '#414547' } },
    { if: { colour: 'brand' }, tokens: { color: '#4b286d' } },
    { if: { colour: 'dark' }, tokens: { color: '#2c2e30' } },
    { if: { colour: 'light' }, tokens: { color: '#676e73' } },
    { if: { colour: 'positive' }, tokens: { color: '#2b8000' } },
    { if: { colour: 'warning' }, tokens: { color: '#c77539' } },
    { if: { colour: 'danger' }, tokens: { color: '#c12335' } },
    { if: { colour: 'black' }, tokens: { color: '#000000' } },
    { if: { colour: 'white' }, tokens: { color: '#ffffff' } },
    { if: { colour: 'brand2' }, tokens: { color: '#2b8000' } },
    { if: { colour: 'brand3' }, tokens: { color: '#7c53a5' } },
    {
      if: { colour: 'alternative1' },
      tokens: {
        color: '#4b286d',
        gradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#e53293', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    { if: { colour: 'alternative2' }, tokens: { color: '#4b286d' } },
    { if: { colour: 'alternative3' }, tokens: { color: '#4b286d' } }
  ],
  tokens: {
    color: '#414547',
    fontName: 'HNforTELUSSA',
    fontScaleCap: 64,
    fontSize: 16,
    fontWeight: '400',
    gradient: null,
    letterSpacing: 0,
    lineHeight: 1.5,
    superScriptFontSize: 16,
    textTransform: 'none'
  }
}
export default theme
